var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasAdvantages
    ? _c(
        "div",
        { staticClass: "advantages" },
        [
          _c("h2", { staticClass: "advantages__title" }, [
            _vm._v("\n    Наши преимущества\n  ")
          ]),
          _c("vue-client-only", [
            _c(
              "div",
              { staticClass: "advantages__inner" },
              [
                _vm.isSliderMode
                  ? _c("swiper", {
                      staticClass: "advantages__slider",
                      attrs: {
                        items: _vm.ADVANTAGES,
                        dots: "",
                        "slides-to-show": _vm.adaptive.isMobile ? 1 : 2
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c("advantage", {
                                  staticClass: "advantages__item",
                                  attrs: { data: item }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2248367187
                      )
                    })
                  : _vm._l(_vm.ADVANTAGES, function(advantage) {
                      return _c("advantage", {
                        key: advantage.id,
                        staticClass: "advantages__item",
                        attrs: { data: advantage }
                      })
                    })
              ],
              2
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }